/**
 * Check if string is ISO date format.
 *
 * @param {string} str Input string.
 */
export function isIsoString(string) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(string)) return false;

  const d = new Date(string);

  return d.toISOString() === string;
}
